import { useQuery, useMutation } from "react-query";
import {
  getAllProperties,
  getPropertiesByCustomer,
  approveProperty,
  requestValidationProperty,
  removeProperties,
  getPropertyById,
  updateProperty,
  getPropertiesByUser,
  addProperty,
  approveSingleProperty,
} from "../../api/Onboarding/onboarding-properties";

// Self service - get all properties
const useGetAllProperties = (options = {}) => {
  const records = useQuery("getAllProperties", getAllProperties, options);
  return records;
};

// Self service - get properties by customer
const useGetPropertiesByCustomer = (customeId, options = {}) => {
  const records = useQuery(
    ["getPropertiesByCustomer", customeId],
    () => getPropertiesByCustomer(customeId),
    options,
  );
  return records;
};

// Self service - Multiple Approve Properties
const useApproveProperty = (options = {}) => {
  return useMutation(approveProperty, options);
};

// Self service - Single Approve Properties
const useApproveSingleProperty = (options = {}) => {
  return useMutation(approveSingleProperty, options);
};
// Self service - upsert properties draft
const useRequestValidationProperty = (options = {}) => {
  return useMutation(requestValidationProperty, options);
};

// Self service - upsert properties draft
const useRemoveProperties = (options = {}) => {
  return useMutation(removeProperties, options);
};

// Self service - get properties by id
const useGetPropertyById = (prpertyId, options = {}) => {
  const records = useQuery(
    ["getPropertyById", prpertyId],
    () => getPropertyById(prpertyId),
    options,
  );
  return records;
};

const useUpdateProperty = (options = {}) => {
  return useMutation(updateProperty, options);
};

const useAddProperty = (options = {}) => {
  return useMutation(addProperty, options);
};

// Self service - get properties by customer
const useGetPropertiesByUser = (userId, options = {}) => {
  const records = useQuery(
    ["getPropertiesByUser", userId],
    () => getPropertiesByUser(userId),
    options,
  );
  return records;
};

export {
  useGetAllProperties,
  useGetPropertiesByCustomer,
  useApproveProperty,
  useRequestValidationProperty,
  useRemoveProperties,
  useGetPropertyById,
  useUpdateProperty,
  useGetPropertiesByUser,
  useAddProperty,
  useApproveSingleProperty,
};
